import { find, go } from 'fxjs/es';

export const getBp = (event, bp_id) => {
  return go(
    event.bps,
    find(({ base_product_id }) => base_product_id == bp_id),
  );
};
